var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tile-grid',_vm._l((_vm.getDevices),function(service){return _c('service-tile',{key:service.id,attrs:{"service":service,"selected":false}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }